<template>
  <div>
    <div class="loader">
      {{ $t("loading.loading") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    i18n: Object,
  },
};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  padding-top: 100px;
  padding-left: 100px;
  background: #ffffff;
}
</style>
